function initListing(parent, initialPage, tags, category, sort) {
    var numFilters = 0;

    // Listing app
    const Listing = Vue.createApp({
        data() {
            return {
                //defaults
                results: [],
                numResults: 0,
                numPages: 1,
                currentPage: initialPage,
                parent: parent,
                tags: tags,
                category: category,
                sort: sort
            };
        },
        methods: {
            fetchResults: function () {
                let t = this;
                const qs = `&page=${t.currentPage}&tags=${t.tags}&category=${t.category}&sort=${t.sort}`;
                this.navigate(qs);
                if (numFilters++ !== 0) {
                    history.pushState({ qs: qs, sort: t.sort, category: t.category }, 'page', `?parent=${t.parent}${qs}`);
                }
                else {
                    history.replaceState({ qs: qs, sort: t.sort, category: t.category }, 'page', `?parent=${t.parent}${qs}`);
                }
            },
            navigate: function (qs, sort, category) {
                let t = this;
                // get the results
                $.getJSON(`/umbraco/api/listingapi/getlisting?parent=${t.parent}${qs}`, function (data) {
                    t.results = data.results;
                    t.numResults = data.numResults;
                    t.numPages = data.numPages;
                    t.currentPage = data.currentPage;
                });

                // make dropdown selections
                if (sort !== undefined) t.sort = sort;
                if (category !== undefined) t.category = category;
            },
            changeSort: function (sort) {
                if (this.sort === sort) this.sort = '';
                else this.sort = sort;
                this.go(1);
            },
            changeCategory: function (category) {
                if (this.category === category) this.category = '';
                else this.category = category;
                this.go(1);
            },
            go: function (n) {
                // switch to page n
                this.currentPage = n;
                this.fetchResults();
            }
        },
        created: function () {
            this.fetchResults();
        }
    });
    const vm = Listing.mount('#listing');

    // back/forward buttons
    $(window).on("popstate", function () {
        if (history.state) {
            vm.navigate(history.state.qs, history.state.sort, history.state.category);
        }
    });

    $('.mob-filters .sorts .item').click(function (e) {
        e.preventDefault();
        vm.changeSort($(this).data('val'));
    });

    $('.mob-filters .categories .item').click(function (e) {
        e.preventDefault();
        vm.changeCategory($(this).data('val'));
    });

}